import React, {useEffect, useState} from "react";
import "./Message.css";
import { Message as MessageType } from "../../../../types/Message";
import {getMessageById, setEventStatus} from "../../../../services/api";
import { useChat } from "../../Layout/ChatProvider/ChatProvider";
import menuOpenIcon from "../../../../assets/menu-open.png";
import menuClosedIcon from "../../../../assets/menu-closed.png";
import clockIcon from "../../../../assets/clock.png";
import aiAvatar from "../../../../assets/ai-avatar.png";
import userLogo from "../../../../assets/clock.png";
import hkAvatar from "../../../../assets/hk-avatar.png"

interface MessageProps {
    message: MessageType;
}

const Message: React.FC<MessageProps> = ({ message }) => {
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false); // Track API request
    const [showPopup, setShowPopup] = useState(false);
    const { companyId, deleteMessage, fetchMessages } = useChat();
    const [reportData, setReportData] = useState<any[]>([]);
    const [popupClosing, setPopupClosing] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (showPopup && companyId && message.id) {
                const dataArray = await getMessageById(
                    companyId,
                    message.metadata?.message_id?.toString() || ""
                );
                console.log("MESSAGE_DATA: ", dataArray);
                if (Array.isArray(dataArray)) {
                    setReportData(dataArray);
                }
            }
        };
        fetchData();
    }, [showPopup]);

    const formattedTime = message.created_at
        ? new Date(message.created_at * 1000).toLocaleTimeString('he-IL', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false
          }) + ' | ' + new Date(message.created_at * 1000).toLocaleDateString('he-IL', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
          }).replaceAll(".","/")
        : "";

    const alignmentClass = message.role === "user" ? "message-user" : "message-assistant";
    const isUserMessage = message.role === "user";
    const isAiMessage = (message.metadata?.type === "AI") || (message.metadata?.event_status === "CONFIRMED");
    const isHkMessage = (message.metadata?.type === "HK") || (message.metadata?.event_status);
    const isEventMessage = Boolean(message.metadata?.event_status);
    const isDoneEventType = message.metadata?.type === "DONE";
    console.log(message.metadata?.event_status?.toLowerCase())
    const isShowEventButtons = message.metadata?.event_status === "NEW";
    //const isEventMessage = message.metadata?.type === "EVENT";

    const handleDelete = async () => {
        if (!companyId) {
            return;
        }
        setIsDeleting(true); // Make message transparent
        try {
            await deleteMessage(companyId, message.id); // API call to delete
        } catch (error) {
            setIsDeleting(false); // Restore if deletion fails
        }
    };

    const handleOpenPopup = () => {
        setPopupClosing(false);
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setPopupClosing(true);
        setTimeout(() => {
            setShowPopup(false);
            setPopupClosing(false);
        }, 300); // match CSS animation duration
    };

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            handleClosePopup();
        }
    };

    return (
        <div className={`message ${alignmentClass} ${isDeleting ? "deleting" : ""}`}>
            {isUserMessage && (
                <div className="delete-container">
                    {!confirmDelete ? (
                        <button className="delete-button" onClick={() => setConfirmDelete(true)}>
                            <img src={menuClosedIcon} alt="Delete" className="delete-icon" />
                        </button>
                    ) : (
                        <div className="confirm-delete">
                            <button className="confirm-yes" onClick={handleDelete}>Delete</button>
                            <button className="confirm-no" onClick={() => setConfirmDelete(false)}>
                                <img src={menuOpenIcon} alt="Cancel" className="delete-icon" />
                            </button>
                        </div>
                    )}
                </div>
            )}
            <div className="message-and-avatar-container">
                {isAiMessage && (
                    <img src={aiAvatar} alt="aiAvatar" className="ai-avatar-container" />
                )}
                {isHkMessage && !isAiMessage && (
                    <img src={hkAvatar} alt="hkAvatar" className="hk-avatar-container" />
                )}
                <div className="message-and-timestamp-container">
                    <div className="message-container">
                        <div
                            className={`message-bubble ${
                                isEventMessage && ["unrelevant", "new"].includes(message.metadata?.event_status?.toLowerCase() || "")
                                    ? `event-${message.metadata?.event_status?.toLowerCase() || ""}`
                                    : ""
                            }`}
                            style={{ alignSelf: isUserMessage ? "flex-end" : "flex-start" }}
                        >
                            <p className="message-text" dir="auto">
                                {message.content.split("\n").map((line, index) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </p>
                            {isDoneEventType && (
                                <button className="view-reports" onClick={handleOpenPopup}>
                                    דו״ח תקציבי
                                    <span className="view-reports-icon" style={{marginRight: '8px', display: 'inline-flex', alignItems: 'center'}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12.05 10.96H8.93C8.51579 10.96 8.18 10.6242 8.18 10.21C8.18 9.79579 8.51579 9.46 8.93 9.46H12.05C12.4642 9.46 12.8 9.79579 12.8 10.21C12.8 10.6242 12.4642 10.96 12.05 10.96Z" fill="#0C4068"/>
                                            <path d="M8.93 12.57H15.07C15.4842 12.57 15.82 12.9058 15.82 13.32C15.82 13.7342 15.4842 14.07 15.07 14.07H8.93C8.51579 14.07 8.18 13.7342 8.18 13.32C8.18 12.9058 8.51579 12.57 8.93 12.57Z" fill="#0C4068"/>
                                            <path d="M14.23 15.5H8.93C8.51579 15.5 8.18 15.8358 8.18 16.25C8.18 16.6642 8.51579 17 8.93 17H14.23C14.6442 17 14.98 16.6642 14.98 16.25C14.98 15.8358 14.6442 15.5 14.23 15.5Z" fill="#0C4068"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.27 2C15.0792 1.99888 15.7474 2.63193 15.79 3.44C18.1649 3.70703 19.9696 5.70032 20 8.09V18.18C19.9945 20.8011 17.8711 22.9245 15.25 22.93H8.75C6.12893 22.9245 4.0055 20.8011 4 18.18V8.09C4.03041 5.70032 5.83508 3.70703 8.21 3.44C8.25747 2.63419 8.9228 2.00388 9.73 2H14.27ZM14.29 3.44H9.73V4.63H14.29V3.44ZM18.5 18.18C18.5 19.9766 17.0465 21.4345 15.25 21.44H8.75C6.95345 21.4345 5.49999 19.9766 5.5 18.18V8.09C5.50398 6.49887 6.65936 5.14458 8.23 4.89C8.35276 5.62136 8.98843 6.15532 9.73 6.15H14.27C15.0116 6.15532 15.6472 5.62136 15.77 4.89C17.3406 5.14458 18.496 6.49887 18.5 8.09V18.18Z" fill="#0C4068"/>
                                        </svg>
                                    </span>
                                </button>
                            )}
                        </div>
                        {formattedTime && (
                            <div className="timestamp-container" style={{ alignSelf: isUserMessage ? "flex-end" : "flex-start" }}>
                                {isShowEventButtons && (
                                    <div className="event-statuses-container">
                                        <button
                                            className="button-confirm"
                                            onClick={() =>
                                                setEventStatus(Number(message.id), "CONFIRMED").then(() => {
                                                    if (companyId) fetchMessages(companyId);
                                                })
                                            }
                                        >
                                            מאושר
                                        </button>
                                        <button
                                            className="button-not-relevant"
                                            onClick={() =>
                                                setEventStatus(Number(message.id), "UNRELEVANT").then(() => {
                                                    if (companyId) fetchMessages(companyId);
                                                })
                                            }
                                        >
                                            לא רלוונטי
                                        </button>
                                    </div>
                                )}
                                <img src={clockIcon} alt="clock" className="clock-icon" />
                                <span
                                    className="message-timestamp"
                                >
                                    {formattedTime}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
                {isUserMessage && (
                    <img src={userLogo} alt="userAvatar" className="user-avatar-container" />
                )}
            </div>
            {!isUserMessage && (
                <div className="delete-container">
                    {!confirmDelete ? (
                        <button className="delete-button" onClick={() => setConfirmDelete(true)}>
                            <img src={menuClosedIcon} alt="Delete" className="delete-icon" />
                        </button>
                    ) : (
                        <div className="confirm-delete">
                            <button className="confirm-no" onClick={() => setConfirmDelete(false)}>
                                <img src={menuOpenIcon} alt="Cancel" className="delete-icon" />
                            </button>
                            <button className="confirm-yes" onClick={handleDelete}>Delete</button>
                        </div>
                    )}
                </div>
            )}
            {showPopup && (
                <div className={`report-bottomsheet-overlay${popupClosing ? ' closing' : ''}`} onClick={handleOverlayClick}>
                    <div className={`report-bottomsheet${popupClosing ? ' closing' : ''}`} onClick={e => e.stopPropagation()}>
                        <div className="report-bottomsheet-content">
                            <div className="report-bottomsheet-header">
                                <div className="report-bottomsheet-date-download-title">
                                    <div className="report-bottomsheet-title">דו"ח תקציבי</div>
                                    <span className="report-bottomsheet-date">
                                        {new Date().toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                    </span>
                                    <span className="report-bottomsheet-download">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path d="M21.875 16.125V20.2917C21.875 20.8442 21.6555 21.3741 21.2648 21.7648C20.8741 22.1555 20.3442 22.375 19.7917 22.375H5.20833C4.6558 22.375 4.12589 22.1555 3.73519 21.7648C3.34449 21.3741 3.125 20.8442 3.125 20.2917V16.125M7.29167 10.9167L12.5 16.125M12.5 16.125L17.7083 10.9167M12.5 16.125V3.625" stroke="#0C4068" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </div>
                                <button className="report-bottomsheet-close" onClick={handleClosePopup}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                            <path d="M10.0484 9.63137L16.0616 3.63859C16.3128 3.38501 16.3128 2.9742 16.0616 2.72062C15.8148 2.46251 15.4073 2.45476 15.151 2.7033L9.13789 8.69608L3.20206 2.7033C3.08037 2.57353 2.91104 2.5 2.73389 2.5C2.55675 2.5 2.38742 2.57353 2.26573 2.7033C2.04299 2.9483 2.04299 3.32431 2.26573 3.56931L8.20155 9.55343L2.18842 15.5376C1.93719 15.7911 1.93719 16.2019 2.18842 16.4555C2.30802 16.579 2.4725 16.6479 2.6437 16.646C2.81819 16.6603 2.99118 16.6043 3.12475 16.4902L9.13789 10.4974L15.151 16.5594C15.2706 16.6829 15.4351 16.7518 15.6063 16.75C15.7773 16.7508 15.9414 16.6821 16.0616 16.5594C16.3128 16.3059 16.3128 15.8951 16.0616 15.6415L10.0484 9.63137Z" fill="#7E7E7E"/>
                                        </svg>
                                </button>
                            </div>
                            <table className="report-table">
                                <thead>
                                    <tr>
                                        <th className="th-first">קטגוריה</th>
                                        <th>חודש קודם</th>
                                        <th>תקציב</th>
                                        <th>בפועל עד היום</th>
                                        <th>בפועל חודש קודם עד אותו תאריך</th>
                                        <th>צפי בתזרים</th>
                                        <th>שורה תקציבית</th>
                                        <th>פער</th>
                                        <th>פער חודש הבא</th>
                                        <th className="th-last">הודעה</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.map((item: any) => (
                                        <tr key={item.keyName}>
                                            <td>{item.keyName || ""}</td>
                                            <td className="numeric-cell">{item.LastMonrhTotal != null ? Math.round(item.LastMonrhTotal).toLocaleString() : ""}</td>
                                            <td className="numeric-cell">{item.total != null ? Math.round(item.total).toLocaleString() : ""}</td>
                                            <td className="numeric-cell">{item.totalKeyUse != null ? Math.round(item.totalKeyUse).toLocaleString() : ""}</td>
                                            <td className="numeric-cell">{item.lastPeriodTotal != null ? Math.round(item.lastPeriodTotal).toLocaleString() : ""}</td>
                                            <td className="numeric-cell">{item.totalCashflowWithouAgent != null ? Math.round(item.totalCashflowWithouAgent).toLocaleString() : ""}</td>
                                            <td className="numeric-cell">{item.total_agent != null ? Math.round(item.total_agent).toLocaleString() : ""}</td>
                                            <td className={`numeric-cell ${item.diff < 0 ? 'report-table-negative' : 'report-table-positive'}`}>{item.diff != null ? Math.round(item.diff).toLocaleString() : ""}</td>
                                            <td className="numeric-cell">{item.nextMonth_diff != null ? Math.round(item.nextMonth_diff).toLocaleString() : ""}</td>
                                            <td className="report-table-checkmark-container">{item.isMessage === true ? <span className="report-table-checkmark">✓</span> : ""}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Message;
